"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * ModalScreen renders behind the modal content and acts as the clickable
 * element that closes the modal when users click outside of the modal content
 *
 */


var ModalScreen = function ModalScreen(_ref) {
  var onClick = _ref.onClick;
  return _react.default.createElement("button", {
    type: "button",
    className: "ModalScreen absolute w-full cursor-default",
    style: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    onClick: onClick,
    "aria-label": "Close modal"
  });
};

ModalScreen.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = ModalScreen;
exports.default = _default;